const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

/**
 * Redact tool argument JSON for non-workspace-admins when values may contain PII (crm-chat-ui-spec §15 #6).
 */
export function redactToolArgumentsJson(
  args: Record<string, unknown>,
  canViewSensitive: boolean
): string {
  if (canViewSensitive) {
    return JSON.stringify(args, null, 2);
  }
  const serialized = JSON.stringify(args);
  if (EMAIL_PATTERN.test(serialized)) {
    return '"[hidden]"';
  }
  return JSON.stringify(args, null, 2);
}
